// import { encode as base64_encode } from "base-64";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import conf from "../config";
import utf8 from "utf8";
import Cookies from "js-cookie";
import { json } from "d3";
import config from "../config";

class WASLVehicleStore {
  WASLVehicleArray = [];
  getVehiclesUsingCompanyId = [];
  CompanyIdentityNumbers = [];
  WASLVehicleStatus = [];
  inquiryStatus = [];
  waslactivity = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      WASLVehicleArray: observable,
      CompanyIdentityNumbers: observable,
      total: observable,
      loading: observable,
      WASLVehicleStatus: observable,
      inquiryStatus: observable,
      loadData: action,
      registerVehicle: action,
      getVehiclesByCompanyId: action,
      getVehicleInfo: action,
      getCompanyIdentityNo: action,
      getWASLVehicleStatus: action,
      getWASLvehicleActivity: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    vehicleId,
    sequenceNo,
    UcompanyId,
  }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      sequenceNo: sequenceNo,
      offset: offset,
      limit: limit,
      UcompanyId: UcompanyId,
    };

    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/waslvehicle/getvehicleList", postData);
    } else {
      var base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=wasl&a=vehicleList", "postData=" + base64Input);
    }

    this.WASLVehicleArray = response?.data?.data?.company;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async registerVehicle(data) {
    var postData = data;

    console.log(data)
    if (config.pythonReport == 1) {
      // var response = await postApi
      //   .getClient("")
      //   .post("http://localhost:3061/waslvehicle/registerwaslVehicle", postData);
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/waslvehicle/registerwaslVehicle", postData);

    } else {
      const base64Input = await utf8.encode(JSON.stringify(postData));
      const base2 = JSON.stringify(base64_encode(base64Input));

      // console.log(base2);
      var response = await postApi
        .getClient()
        .post("index.php?c=wasl&a=registerVehicle", "postData=" + base2);
    }
    return response;
  }

  async getVehiclesByCompanyId({ companyId }) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);

    this.getVehiclesUsingCompanyId = response?.data?.data;

    // return response?.data?.data
  }

  async getVehicleInfo(vehicleId) {
    var postData = { vehicleId: vehicleId };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/waslvehicle/vehicleInfo", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=wasl&a=getVehicleInfo", "postData=" + base64Input);
    }
    this.total = parseInt(response?.data?.data?.TotalCount);
    return response.data.data;
  }

  async exportExcel(getData) {
    if (config.pythonReport == 1) {
      try {
        var response = await postApi.getClient("")
        .post(
          config.NodeUrl + "/waslvehicle/exportWASLReport",
          getData,
          {
            responseType: "blob",
          }
        );
        // .post("http://localhost:3061/waslvehicle/exportWASLReport",
        //   getData,
        //   {
        //     responseType: "blob",
        //   }
        // );

        // console.log(response, "res");

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "WASL Vehicle Report.xlsx";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the file", error);
      }
    } else {
      let lang = "english";
      window.location.href =
        conf.baseURL +
        "index.php?c=wasl&a=exportwaslvehicleexcel&cid=" +
        getData.companyId +
        "&UcompanyId=" +
        getData.UcompanyId +
        "&vid=" +
        getData.vehicleId +
        "&sno=" +
        getData.sequenceNo +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async getCompanyIdentityNo(companyId) {
    var postData = { companyId: companyId };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/waslvehicle/getIdentityNo", {
          postData: postData,
        });
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=company&a=getIdentityNo", "postData=" + base64Input);
    }
    this.CompanyIdentityNumbers = response?.data?.data;

    return response;
  }

  async deleteRecord({ Id, companyId, waslkey, userId }) {
    var postData = {
      waslId: Id,
      companyId: companyId,
      waslVehicleKey: waslkey,
      userId: userId,
    };

    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/waslvehicle/delete", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=wasl&a=deleteVehicle", "postData=" + base64Input);
    }
    return response;
  }

  async getWASLVehicleStatus(record) {
    var postData = { Id: record.Id, waslVehicleKey: record.waslVehicleKey };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/waslvehicle/vehicle-inquiry", {
          postData: postData,
        });
        if (response.data.success == "S" && response?.data?.data?.resultCode) {
      this.WASLVehicleStatus = response?.data?.data?.resultCode;
      response = "";
    } else if (response?.data?.data && response.data.success == "S") {
      this.inquiryStatus = response?.data?.data;
    } else {
      this.WASLVehicleStatus = response?.data?.data;
      response = "";
    }
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=wasl&a=getwaslvehiclestatus",
          "postData=" + base64Input
      );
        if (
      response.data.success == "S" &&
      JSON.parse(response?.data?.data)?.resultCode
    ) {
      this.WASLVehicleStatus = JSON.parse(response?.data?.data)?.resultCode;
      response = "";
    } else if (response?.data?.data && response.data.success == "S") {
      this.inquiryStatus = JSON.parse(response?.data?.data);
    } else {
      this.WASLVehicleStatus = response?.data?.data;
      response = "";
    }
    }
    // if (response?.data?.data && response?.data?.success == "S2") {
    //   this.WASLVehicleStatus = response?.data?.data;
    //   response = "";
    // }
    // const b = response.data;
    // console.log(b);
    // this.WASLCompanyStatus = response.data.errors[0][0];
    // return response;
    // if (response?.data?.data) {
    //   this.inquiryStatus = JSON.parse(response?.data?.data);
    // } else {
    //   this.WASLVehicleStatus = response?.data?.errors[0][0];
    // }
    // var response = {
    //   data: '{"referenceKey":"EE3A429E-E125-4621-B9FA-67E81F23B1C7","plate":{"rightLetter":"\u0627","middleLetter":"\u062d","leftLetter":"\u0642","number":"3800"},"vehicleIMEI":"359633101048796","vehicleLocationInformation":{"latitude":27.506562,"longitude":41.75817,"vehicleStatus":"MOVING","actualTime":"2024-07-22T22:02:41","receivedTime":"2024-07-22T22:05:56.742"},"operatingCompanies":[{"referenceKey":"F38518BB-3119-4D31-B233-C338A72174D3","name":"\u0645\u0624\u0633\u0633\u0629 \u0636\u064a\u062f\u0627\u0646 \u0645\u062d\u0645\u062f \u0631\u0634\u064a\u062f \u0627\u0644\u062a\u0645\u064a\u0645\u064a \u0644\u0644\u0646\u0642\u0644\u064a\u0627\u062a","isVehicleValid":false,"vehicleRejectionReason":"latitude_not_send","registrationTime":"2022-05-17T15:51:07.393"}]}',
    //   message: "Vehicle Inquiry Service",
    //   success: "S",
    // };
    // var response = {
    //   data: "Vehicle Not Registerd!",
    //   message: "Vehicle Inquiry Service",
    //   success: "S2",
    // };

    // var response = {
    //   data: '{"resultCode":"vehicle_not_found","success":false}',
    //   message: "Vehicle Inquiry Service",
    //   success: "S",
    // };

  
  
    return response?.data?.data;
  }

  async getWASLvehicleActivity() {
    var postData = {
      roleId2: Number(JSON.parse(base64_decode(Cookies.get("data"))).roleId2),
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      status: 1,
    };
 
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/vehicle/getwaslactivity", {
        postData,
      });

    this.waslactivity = response?.data.data;

    return response?.data;
  }
}

export default WASLVehicleStore;
